<template lang="pug" src='./newBuildings.pug'>
</template>

<script>
import uploadPopUp from '@/commonSite/uploadFiles'
import helpButton from 'Common/components/help-button'
import _ from 'lodash'
import Vue from 'vue'

export default {
	name: 'new-buildings',
	components: {
		uploadPopUp, helpButton
	},
	props: ['newDwelling'],
	data: function () {
		return {
			navLinks: {},
			products: [],
			sqft: '',
			status: 'not_accepted',
			NofUnique: '',
			opUpFourDwellingsYes: '',
			newFloor: '',
			upFourDwellings: false,
			uniqueUnitType: 1,	// always : >=1
			moreOneDwelling: false,
			exstFloor: '',
			adtnFloor: '',
			adtnOnlyFloor: '',
			lowEstimate: 0,
			hiEstimate: 0,
			selfServe: 0,
			estmtParts: {
				new: true,
				existingPlusAdd: false,
				add: false
			},
			totalEstimate: 0
		}
	},
	created () {
		this.price = this.$e24Common.storageService.findItem('config', true).estimator
		Vue.e24Common.productService.findAll().then((products) => {
			// console.log('product loaded', products)
			this.products = products
			this.products = _.map(this.products, (prod) => {
				// prod.price = prod.price.toFixed(2)
				prod.price = parseFloat(prod.price).toFixed(2)
				// console.log('prod ', prod.price)
				return prod
			})
			this.dataReady = true
		})
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
	},
	methods: {
		validateNumber (anInput) {
			let reg = new RegExp('^[0-9]*$', 'g') // this only detect numbers
			// let reg2 = new RegExp('^-?\d*(\.\d+)?$') // this detects .0 and -9
			if (!reg.test(anInput)) {
				return false
			} else {
				return true
			}
		},
		checkUpFourDwellings (value) {
			if (value) {
				if (this.upFourDwellings) {
					return true
				} else {
					return false
				}
			} else {
				if (this.upFourDwellings) {
					return false
				} else {
					return true
				}
			}
		},
		findBySku (sku) {
			return _.find(this.products, { sku: sku.toString() })
		},
		// selType (type) {
		// 	this.switchType(type)
		// },
		dwellingsSel () {
			this.moreOneDwelling = !this.moreOneDwelling
			this.doNewBuilding(false)
		},
		setUnitTypeNum (uTypeNum) {
			this.uniqueUnitType = uTypeNum
			// this.uniqueUnitType = this.uniqueUnitType
			this.doNewBuilding(false)
			if (uTypeNum > 4) {
				this.upFourDwellings = true
			} else {
				this.upFourDwellings = false
			}
		},
		doNewBuilding (sel) {
			// if we clicked on the 'New Building' radio button
			// copy any addition values into the newFloor area,
			if (sel) {
				if (this.adtnFloor > 0) {
					this.newFloor = this.adtnFloor
				}
				if (this.adtnOnlyFloor > 0) {
					this.newFloor = this.adtnOnlyFloor
				}
			}

			// clear the other area inputs
			this.exstFloor = ''
			this.adtnFloor = ''
			this.adtnOnlyFloor = ''

			if (this.validateNumber(this.newFloor) === false && !this.upFourDwellings) {
				return
			}
			// console.log(`this.upFourDwelling ${this.upFourDwellings}`)
			// calculate the estimate
			if (this.newFloor > 0 || this.moreOneDwelling) {
				var extraDwellingsCost = 0
				var cost = Math.max(this.price.resid.newBuildingBase, (this.newFloor * this.price.resid.newBuildingPerFoot) - this.price.resid.estmOffset)
				if (this.moreOneDwelling) {
					if (this.uniqueUnitType >= 1) {
						// var estimate = this.price.resid.multiFamilyBase
						if (this.uniqueUnitType >= 2) {
							extraDwellingsCost = (this.uniqueUnitType - 1) * this.price.resid.uniqueUnitType
							var estimate = cost + extraDwellingsCost
						} else {
							estimate = cost
						}
						// extraDwellingsCost = this.uniqueUnitType * this.price.resid.uniqueUnitType
						// var estimate = Math.max(this.price.resid.multiFamilyBase, extraDwellingsCost)
						this.lowEstimate = estimate
						this.hiEstimate = estimate + (2 * this.price.resid.estmOffset)
					} else {
						this.lowEstimate = cost - this.price.resid.estmOffset
						this.hiEstimate = cost - this.price.resid.estmOffset
						alert('Unique unit type must be greater or equal than 1')
					}
				} else {
					this.totalEstimate = Math.round(Math.max(this.price.resid.newBuildingBase, (cost - this.price.resid.estmOffset)))
					this.lowEstimate = this.totalEstimate
					this.hiEstimate = this.totalEstimate + (this.price.resid.estmOffset * 2)
				}
				if (this.newDwelling === 'true') {
					this.selfServe = this.findBySku(1001).price
					// this.selfServe = this.price.resid.newBuildingSelfServe
				}
				if (this.newDwelling === 'false') {
					this.selfServe = this.findBySku(1002).price
					// this.selfServe = this.price.resid.exstPlusAdtnSelfServe
				}
				if (this.newDwelling === 'none') {
					this.selfServe = this.findBySku(1001).price
					// this.selfServe = this.price.resid.adtnOnlySelfServe
				}
			} else {
				this.lowEstimate = 0
				this.hiEstimate = 0
				this.selfServe = 0
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/residentialWizards/newBuildings.vue